import { useTheme } from 'next-themes';
import { CustomIcon } from '../CustomIcon';

const ThemeToggle = () => {
  const { theme, setTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      className='flex relative gap-[0.75rem] lg:gap-[1.5rem] cursor-pointer dark:bg-[#1D1D1D] bg-[#F5F5F5] p-[0.5rem] lg:p-[1rem] rounded-full dark:shadow-none shadow-[0px_1px_2.3px_0px_#0000002E]'
    >
      <div
        className={`indicator absolute top-1/2 translate-y-[-50%] left-[0.25rem] lg:left-[0.5rem] dark:bg-[#373737] bg-[#FFFFFF] h-[calc(100%_-_0.5rem)] lg:h-[calc(100%_-_1rem)] w-[calc(50%_-_0.375rem)] lg:w-[calc(50%_-_0.75rem)] rounded-full transition-all duration-300 ${!isDark && 'translate-x-[115%]'}`}
      ></div>

      <div className='flex gap-[0.75rem] lg:gap-[1.5rem]'>
        <div className={`dark bg-transparent relative z-10 ${!isDark && 'brightness-[0.5]'}`}>
          <CustomIcon type="moonIcon" cursorPointer className='w-auto h-[1.5rem] lg:h-[2rem]' />
        </div>

        <div className='light bg-transparent relative z-10'>
          {isDark ? (
            <CustomIcon type="sunIcon" cursorPointer className='w-auto h-[1.5rem] lg:h-[2rem]' />
          ) : (
            <CustomIcon type="sunIconLight" cursorPointer className='w-auto h-[1.5rem] lg:h-[2rem]' />
          )}
        </div>
      </div>
    </button>
  );
}

export default ThemeToggle